// Append-only registry — never reorder: the array order is the addition date
// (oldest first), and the dev-tools panel lists flags in this order.
export const FEATURE_FLAGS = [
  { key: 'multiPhase', addedAt: '2026-09-28' },
  { key: 'hubspotAssessmentSearch', addedAt: '2026-10-01' },
  { key: 'v2Creation', addedAt: '2026-10-05' }
] as const

export type FeatureFlag = (typeof FEATURE_FLAGS)[number]['key']
